import { api } from './api';

export interface ProgramTemplate {
  title: string;
  pmk_template_id: string;
}

export interface ProgramOption {
  id: string;
  label: string;
  description?: string;
  program_price: number;
  clinic_facilitation_fee: number;
  includes_services?: string[];
  is_subscription: boolean;
  subscription_frequency?: 'weekly' | 'monthly' | 'quarterly';
  sort_order: number;
}

export interface Program {
  id: string;
  title: string;
  subtitle: string;
  inclusions: string;
  target: string;
  is_deleted: boolean;
  image_key?: string;
  image_url?: string;
  created_at: string;
  updated_at: string;
  program_templates: ProgramTemplate[];
  display_mode?: 'medication_select' | 'protocol_showcase';
  program_options?: ProgramOption[];
}

export interface GetProgramsResponse {
  success: boolean;
  data: Program[];
  message: string;
}

/**
 * Get all programs for clinic users
 */
export const getAllPrograms = async (): Promise<Program[]> => {
  const response = await api.get<GetProgramsResponse>('/programs');
  return response?.data;
};

